export { default } from "./CustomBorderedText"
